var map = {
	"./bsc2016_work.png": 333,
	"./cba2016_paper.png": 334,
	"./cba2020_paper.png": 335,
	"./iros2023_paper.gif": 336,
	"./jcae2022_paper.gif": 337,
	"./msc2020_work.png": 338,
	"./phd_thesis_math_tools.png": 339,
	"./view_videos.png": 111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 332;